import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination
} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { CollapseAppointment, CollapseContact } from './CollapsRow.js';

const garageApi = new API();

class AdminForms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingAppointments: true,
      appointments: [],
      appointmentsPage: 0,
      appointmentsPageLength: 0,

      loadingContacts: true,
      contacts: [],
      contactsPage: 0,
      contactsPageLength: 0,
    };
  }

  componentDidMount() {
    this.loadAppointments(0);
    this.loadContacts(0);
  }

  loadAppointments(value) {
    garageApi.endpoints.formAppointments.getPage({ get: { limit: 10, offset: (value * 10) } })
      .then((postsGET) => {
        try {
          const appointments = Array.isArray(postsGET.data)
            ? postsGET.data
            : (postsGET.data?.results || []);
          this.setState({ 
            appointments: appointments,
            appointmentsPageLength: postsGET.data?.count ?? appointments.length,
            loadingAppointments: false 
          });
        } catch(e) {
          console.log(e);
          this.setState({ 
            appointments: [],
            loadingAppointments: false 
          });
        }
      })
      .catch(() => {
        this.setState({ 
          appointments: [],
          loadingAppointments: false 
        });
      });
  }

  loadContacts(value) {
    garageApi.endpoints.formContacts.getPage({ get: { limit: 10, offset: (value * 10) } })
      .then((postsGET) => {
        try {
          const contacts = Array.isArray(postsGET.data)
            ? postsGET.data
            : (postsGET.data?.results || []);
          this.setState({ 
            contacts: contacts,
            contactsPageLength: postsGET.data?.count ?? contacts.length,
            loadingContacts: false 
          });
        } catch(e) {
          console.log(e);
          this.setState({ 
            contacts: [],
            loadingContacts: false 
          });
        }
      })
      .catch(() => {
        this.setState({ 
          contacts: [],
          loadingContacts: false 
        });
      });
  }

  deleteAppointment(unikey) {
    if (!window.confirm('Möchten Sie diesen Termin wirklich löschen?')) {
      return;
    }

    var deleteAppointment = this.state.appointments.find((element) => { return element.unikey === unikey; });
    if (!deleteAppointment) return;

    this.setState({ loadingAppointments: true });

    garageApi.endpoints.formAppointments.delete({ id: deleteAppointment.id })
      .then(() => {
        this.loadAppointments(this.state.appointmentsPage);
      })
      .catch(() => {
        this.setState({ loadingAppointments: false });
      });
  }

  deleteContact(unikey) {
    if (!window.confirm('Möchten Sie diesen Kontakt wirklich löschen?')) {
      return;
    }

    var deleteContact = this.state.contacts.find((element) => { return element.unikey === unikey; });
    if (!deleteContact) return;

    this.setState({ loadingContacts: true });

    garageApi.endpoints.formContacts.delete({ id: deleteContact.id })
      .then(() => {
        this.loadContacts(this.state.contactsPage);
      })
      .catch(() => {
        this.setState({ loadingContacts: false });
      });
  }

  changeAppointmentsPage(event, newPage) {
    this.setState({ appointmentsPage: newPage });
    this.loadAppointments(newPage);
  }

  changeContactsPage(event, newPage) {
    this.setState({ contactsPage: newPage });
    this.loadContacts(newPage);
  }

  render() {
    const { 
      loadingAppointments, 
      appointments, 
      appointmentsPage, 
      appointmentsPageLength,
      loadingContacts,
      contacts,
      contactsPage,
      contactsPageLength
    } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/forms': 'Formulare' }}
        title="Formulare"
        loading={(loadingAppointments || loadingContacts) ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Box style={{ padding: '20px' }}>
          {/* Terminanfragen */}
          <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #d32f2f 0%, #f44336 100%)', color: 'white' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box>
                <Typography variant="h5" style={{ fontWeight: 700, marginBottom: '8px' }}>
                  Terminanfragen
                </Typography>
                <Typography variant="body1" style={{ opacity: 0.9 }}>
                  {appointmentsPageLength} {appointmentsPageLength === 1 ? 'Anfrage' : 'Anfragen'} insgesamt
                </Typography>
              </Box>
              <CalendarTodayIcon style={{ fontSize: 50, opacity: 0.3 }} />
            </Box>
          </Paper>

          {!loadingAppointments && (
            <TableContainer component={Paper} elevation={2} style={{ marginBottom: '40px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell padding="checkbox"></TableCell>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>Auto</strong></TableCell>
                    <TableCell><strong>E-Mail</strong></TableCell>
                    <TableCell><strong>Telefon</strong></TableCell>
                    <TableCell><strong>Erstellt</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(appointments) && appointments.length > 0 ? (
                    appointments.map((row) => (
                      <CollapseAppointment 
                        key={row.unikey || row.id} 
                        row={row} 
                        onDelete={this.deleteAppointment.bind(this)}
                      />
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center" style={{ padding: '40px' }}>
                        <Typography variant="body2" color="textSecondary">
                          Noch keine Terminanfragen vorhanden
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                {appointmentsPageLength > 10 && (
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[10]}
                        rowsPerPage={10}
                        count={appointmentsPageLength}
                        page={appointmentsPage}
                        onChangePage={this.changeAppointmentsPage.bind(this)}
                        labelRowsPerPage="Einträge pro Seite:"
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} von ${count}`}
                      />
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
            </TableContainer>
          )}

          {/* Kontaktanfragen */}
          <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #0288d1 0%, #03a9f4 100%)', color: 'white' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box>
                <Typography variant="h5" style={{ fontWeight: 700, marginBottom: '8px' }}>
                  Kontaktanfragen
                </Typography>
                <Typography variant="body1" style={{ opacity: 0.9 }}>
                  {contactsPageLength} {contactsPageLength === 1 ? 'Anfrage' : 'Anfragen'} insgesamt
                </Typography>
              </Box>
              <MailOutlineIcon style={{ fontSize: 50, opacity: 0.3 }} />
            </Box>
          </Paper>

          {!loadingContacts && (
            <TableContainer component={Paper} elevation={2}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell padding="checkbox"></TableCell>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>E-Mail</strong></TableCell>
                    <TableCell><strong>Erstellt</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(contacts) && contacts.length > 0 ? (
                    contacts.map((row) => (
                      <CollapseContact 
                        key={row.unikey || row.id} 
                        row={row}
                        onDelete={this.deleteContact.bind(this)}
                      />
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center" style={{ padding: '40px' }}>
                        <Typography variant="body2" color="textSecondary">
                          Noch keine Kontaktanfragen vorhanden
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                {contactsPageLength > 10 && (
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[10]}
                        rowsPerPage={10}
                        count={contactsPageLength}
                        page={contactsPage}
                        onChangePage={this.changeContactsPage.bind(this)}
                        labelRowsPerPage="Einträge pro Seite:"
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} von ${count}`}
                      />
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
            </TableContainer>
          )}
        </Box>
      </SecuredZone>
    );
  }
}

export default AdminForms;
